import React from "react"
import {MoveTo_Manager} from "./model/manager"
import ModalMoveTo from "./components/modal"
import {ModalMoveTo_Type} from "./@const"
import {EntityType} from "../../gd/const/item"
import ProjectSession from "../../model2/project/project-session"
import Task from "../../model2/task/task"
import Document from "../../model2/doc/document"
import Meeting from "../../model2/meeting/meeting"

type ModalMove_Params = {
    callback?           : callback
    toggleCallback?     : {(isModalOpen: boolean): void}
}

function modalMove(manager: MoveTo_Manager, params?: ModalMove_Params) {
    gd.modal.showV5(
        <ModalMoveTo manager={manager} />,
        {
            toggleCallback: params?.toggleCallback
        }
    )
}

export function modalMoveProject(project:ProjectSession, params?: ModalMove_Params) {
    const manager = new MoveTo_Manager(ModalMoveTo_Type.PROJECT)
    manager.projectsToMove      = [project]
    manager.originalProjectId   = project.treeParent?.id
    manager.targetProject       = project.treeParent
    manager.targetWorkspace     = project.workspace || undefined

    modalMove(manager, params)
}

export function modalMoveTask(task:Task, params?: ModalMove_Params) {
    const manager = new MoveTo_Manager(ModalMoveTo_Type.TASK)
    manager.tasksToMove         = [task]
    manager.originalProjectId   = task.project?.treeParent?.id
    manager.targetProject       = task.project?.treeParent || undefined
    manager.targetWorkspace     = task.project?.workspace || undefined

    modalMove(manager, params)
}

export function modalMoveTaskToTask(task:Task, params?: ModalMove_Params) {
    const manager = new MoveTo_Manager(ModalMoveTo_Type.TASK, EntityType.TASK)
    manager.tasksToMove         = [task]
    manager.originalProjectId   = task.project?.treeParent?.id
    manager.targetProject       = task.project?.treeParent || undefined
    manager.targetWorkspace     = task.project?.workspace || undefined

    modalMove(manager, params)
}

export function modalMoveDocument(document:Document, params?: ModalMove_Params) {
    const manager = new MoveTo_Manager(ModalMoveTo_Type.DOCUMENT)
    manager.documentToMove      = document
    manager.originalProjectId   = document.project?.treeParent?.id
    manager.targetProject       = document.project?.treeParent || undefined
    manager.targetWorkspace     = document.project?.workspace || undefined

    modalMove(manager, params)
}

export function modalMoveMeeting(meeting:Meeting, params?: ModalMove_Params) {
    const manager = new MoveTo_Manager(ModalMoveTo_Type.MEETING)
    manager.meetingToMove       = meeting
    manager.originalProjectId   = meeting.project?.treeParent?.id
    manager.targetProject       = meeting.project?.treeParent || undefined
    manager.targetWorkspace     = meeting.project?.workspace || undefined

    modalMove(manager, params)
}

export function modalMoveMulti(projectsToMove: ProjectSession[], tasksToMove:Task[], params?: ModalMove_Params) {
    const manager = new MoveTo_Manager(ModalMoveTo_Type.MULTI)
    manager.projectsToMove  = projectsToMove
    manager.tasksToMove     = tasksToMove

    modalMove(manager, params)
}